import { WebSocketLink } from 'apollo-link-ws';

const uri = new URL('/api/subscriptions', window.location.origin);
uri.protocol = uri.protocol === 'https:' ? 'wss:' : 'ws:';

export const wsLink = new WebSocketLink({
  uri: uri.toString(),
  options: {
    reconnect: true,
    lazy: true,
    reconnectionAttempts: 50,
    timeout: 20000,
  },
});
